import { gangtokInstance as http } from "./http-common";

const token = "";

const getRevenueCollection = (data) => {
  return http.post("CentralDashboard/GetRevenueCollection", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const fetchFuelConsume = (data) => {
  return http.post("CentralFuelConsume/CentralDash_GetFuelConsume", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const depoDashFuelConsume = (data) => {
  return http.post("DepoDashFuelConsume", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getVehicleStsCount = (data) => {
  return http.post("VehicleStsCount/CentralDash_VehicleStsCount", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getTodaysFuelStatus = () => {
  return http.get("GetTodaysFuelStatus", {
    headers: { Authorization: "Bearer" + token },
  });
};

const getVehicleStatus = (data) => {
  return http.post("VehicleStatus/GetVehicleStatus", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getDutyReportCentral = (data) => {
  return http.post("DutyReport/CentDash_DutyReportCnt", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const newRevenueGenerate = (type) => {
  return http.post(
    `NewRevenueCollection/GetNewRevenueCollection?type=${type}`,
    {
      headers: { Authorization: "Bearer" + token },
    }
  );
};

const getObtsCollection = (type) => {
  return http.post(`CentralOBTS/GetNewObtsCollectionCentral?type=${type}`, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getVehicleTypes = () => {
  return http.get(`VehicleStsCount/getVechtypes`, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getDaywiseRevenue = (data) => {
  return http.post(`RevenueDaywise/GetRevenueCollectionDaywise?date=${data}`, {
    headers: { Authorization: "Bearer" + token },
  });
};

const CentralDashboardService = {
  getRevenueCollection,
  fetchFuelConsume,
  depoDashFuelConsume,
  getVehicleStsCount,
  getTodaysFuelStatus,
  getVehicleStatus,
  getDutyReportCentral,
  newRevenueGenerate,
  getObtsCollection,
  getVehicleTypes,
  getDaywiseRevenue,
};

export default CentralDashboardService;
